module.exports = __webpack_public_path__ + "img/zendesk-logo.4e06511a.svg";